import React from 'react';
import { FadeIn } from './Shared';
import { TreeDeciduous, CheckCircle2 } from 'lucide-react';
export const MetodoRaices = () => {
  const includes = ['La Neurociencia de la Identidad (cómo tus palabras se convierten en su voz interna)', 'Los 3 Pilares de la Autoestima con evaluación y acciones concretas', 'El Test de Seguridad Infantil', 'Elogios vs. Aliento — La diferencia que cambia todo', 'El Diccionario de la Confianza — 40 frases para fortalecer la identidad', 'La Técnica del Espejo Positivo', 'El Protocolo del Todavía', 'El calendario de Micro-Desafíos por edad', 'La Bitácora de Fortalezas', 'La Promesa del Adulto — Una carta para tu hijo'];
  const comparisons = [{
    situacion: 'Tu hijo falla en algo y se derrumba',
    sin: 'No sabés cómo acompañarlo sin minimizar',
    con: 'Protocolo Post-Fracaso. Sabés exactamente qué decir'
  }, {
    situacion: 'Querés elogiar pero no inflar el ego',
    sin: 'Decís "qué inteligente" sin saber el daño que hace',
    con: 'El sistema de aliento que construye resiliencia real'
  }, {
    situacion: 'Tu hijo dice "no puedo" y se rinde',
    sin: 'Lo convencés o lo hacés vos',
    con: 'El Protocolo del Todavía. Una palabra que cambia el cerebro'
  }, {
    situacion: 'Querés construir autoestima genuina',
    sin: 'No sabés si lo que hacés ayuda o daña',
    con: 'Los 3 Pilares con acciones concretas para cada uno'
  }, {
    situacion: 'Tu hijo necesita confianza para enfrentar el mundo',
    sin: 'Esperás que se le pase solo',
    con: 'Micro-Desafíos diarios calibrados para su edad'
  }, {
    situacion: 'Querés que el vínculo sea su superpoder',
    sin: 'Sabés que es importante pero no sabés cómo medirlo',
    con: 'El Test de Apego + Bitácora de Fortalezas'
  }];
  return <section className="py-10 md:py-16 px-4 bg-navy-950" data-id="element-188">
      <div className="max-w-4xl mx-auto" data-id="element-189">
        <FadeIn data-id="element-190">
          <div className="text-center mb-12" data-id="element-191">
            <h2 className="text-2xl md:text-4xl font-serif font-bold text-white flex items-center justify-center gap-3" data-id="element-192">
              <TreeDeciduous className="w-8 h-8 md:w-10 md:h-10 text-green-400" data-id="element-193" />
              🌳 ¿QUÉ AGREGA EL MÉTODO RAÍCES?
            </h2>
            <p className="text-white/90 mt-4 max-w-2xl mx-auto text-lg font-medium" data-id="element-194">
              Para padres que quieren pasar de apagar incendios a construir algo
              que dure para siempre.
            </p>
          </div>

          <div className="space-y-4 mb-12" data-id="element-195">
            {/* Desktop Header */}
            <div className="hidden md:grid grid-cols-3 gap-4 px-6 py-4 bg-navy-900 rounded-t-2xl border-x border-t border-navy-700" data-id="element-196">
              <div className="text-white font-bold text-lg" data-id="element-197">Situación</div>
              <div className="text-red-400 font-bold text-lg" data-id="element-198">
                ❌ Sin Método Raíces
              </div>
              <div className="text-green-400 font-bold text-lg" data-id="element-199">
                ✅ Con Método Raíces
              </div>
            </div>

            <div className="grid gap-3 md:gap-4" data-id="element-200">
              {comparisons.map((item, idx) => <div key={idx} className="bg-navy-800/40 rounded-xl md:rounded-none border border-navy-700/50 md:border-none p-4 md:p-0 overflow-hidden shadow-lg md:shadow-none" data-id="element-201">
                  <div className="md:grid md:grid-cols-3 md:gap-4 md:px-6 md:py-5 md:border-x md:border-b md:border-navy-700 md:hover:bg-navy-800/80 transition-colors" data-id="element-202">
                    <div className="mb-3 md:mb-0 border-b border-navy-700/50 md:border-none pb-3 md:pb-0" data-id="element-203">
                      <span className="text-[9px] uppercase tracking-widest text-gray-400 font-bold md:hidden block mb-0.5" data-id="element-204">
                        Situación
                      </span>
                      <p className="text-white font-bold md:font-medium text-[15px] md:text-lg leading-snug" data-id="element-205">
                        {item.situacion}
                      </p>
                    </div>

                    <div className="flex flex-col gap-2 md:contents" data-id="element-206">
                      <div className="bg-red-500/5 md:bg-transparent p-2.5 md:p-0 rounded-lg border border-red-500/10 md:border-none" data-id="element-207">
                        <span className="text-[9px] uppercase tracking-widest text-red-400 font-bold md:hidden flex items-center gap-1 mb-1" data-id="element-208">
                          <span className="text-[10px]" data-id="element-209">❌</span> Sin Método
                          Raíces
                        </span>
                        <p className="text-gray-200 text-[13px] md:text-base italic md:not-italic leading-tight" data-id="element-210">
                          {item.sin}
                        </p>
                      </div>

                      <div className="bg-green-500/10 md:bg-transparent p-2.5 md:p-0 rounded-lg border border-green-500/20 md:border-none relative" data-id="element-211">
                        <div className="absolute -top-3 left-4 md:hidden text-navy-500 font-bold" data-id="element-212">
                          ↓
                        </div>
                        <span className="text-[9px] uppercase tracking-widest text-green-400 font-bold md:hidden flex items-center gap-1 mb-1" data-id="element-213">
                          <span className="text-[10px]" data-id="element-214">✅</span> Con Método
                          Raíces
                        </span>
                        <p className="text-green-400 font-bold md:font-medium text-[14px] md:text-base leading-tight drop-shadow-sm" data-id="element-215">
                          {item.con}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>)}
            </div>
            {/* Desktop Footer Border */}
            <div className="hidden md:block h-4 bg-navy-900 rounded-b-2xl border-x border-b border-navy-700" data-id="element-216"></div>
          </div>

          <div className="bg-gradient-to-b from-navy-800 to-navy-900 border border-navy-600 rounded-2xl p-6 md:p-10 shadow-2xl relative overflow-hidden" data-id="element-217">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-3/4 h-1 bg-gradient-to-r from-transparent via-green-400/50 to-transparent" data-id="element-218" />
            <h3 className="text-xl md:text-2xl font-serif font-bold text-center text-white mb-8" data-id="element-219">
              ✅ EL MÉTODO RAÍCES INCLUYE:
            </h3>
            <div className="grid sm:grid-cols-2 gap-4" data-id="element-220">
              {includes.map((item, index) => <div key={index} className="flex items-start space-x-3 bg-navy-900/80 border border-navy-700 p-4 rounded-lg hover:border-green-400/30 transition-colors" data-id="element-221">
                  <CheckCircle2 className="w-5 h-5 text-green-400 flex-shrink-0 mt-0.5 drop-shadow-[0_0_5px_rgba(74,222,128,0.5)]" data-id="element-222" />
                  <span className="text-white font-medium text-sm md:text-base leading-tight" data-id="element-223">
                    {item}
                  </span>
                </div>)}
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};